import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Transition } from 'react-transition-group';

import './loyalty.css';
import classNames from 'classnames';

class LoyaltyDesktop extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedCategory: 'offers',
    };
  }

  handleCategory = (catgeory) => {
    this.setState({
      selectedCategory: catgeory,
    });
  };

  handleSignIn = () => {
    if (
      this.props.currentUser &&
      this.props.currentUser.phoneNumber &&
      this.props.userDetails &&
      this.props.userDetails.firstName
    ) {
      //Signed In User don't do anything
    } else {
      this.props.updateOrderStage(1);
    }
  };

  getSizeString = (offer) => {
    return offer.type === '1'
      ? ` ${offer.sizes
          .filter((f) => f.isActive)
          .map((s) => s.name)
          .join(' or ')} `
      : ` `;
  };

  getOfferReward = (offer) => {
    const { storeConfig } = this.props;
    let returnString = [];
    let count = 0;
    if (this.props.pathwayToOffers) {
      let matchingProgress = this.props.pathwayToOffers.filter((f) => {
        return f.offerId === offer._id && f.isUnlocked === true;
      });
      if (matchingProgress.length > 0) count = matchingProgress.length;
      else count = 1;
    } else count = 1;
    offer.rewardItems.forEach((m) => {
      let p =
        Number(m.discountedPrice) <= 0
          ? ` ${count} free`
          : ` ${count} ${storeConfig.currency}${m.discountedPrice}`;
      p =
        p +
        ` ${m.sizes
          .filter((f) => f.isActive)
          .map((m) => m.name)
          .join(' or ')} ${m.categoryDisplayName}`;
      returnString.push(p);
    });
    return offer.isAnyOneItemAvailable
      ? returnString.join(' or ')
      : returnString.join(' and ');
  };

  getOfferUnlockStatus = (offer) => {
    if (this.props.pathwayToOffers) {
      let matchingProgress = this.props.pathwayToOffers.filter((f) => {
        return f.offerId === offer._id;
      });
      if (matchingProgress.length > 0) {
        let orderCount = matchingProgress.reduce((total, obj) => {
          return (total = total + Number(obj.orderCount));
        }, 0);
        if (
          orderCount >=
          (offer.type === '1'
            ? Number(offer.quantity)
            : Number(offer.noOfOrders))
        ) {
          return true;
        } else return false;
      } else return false;
    } else return false;
  };

  getProgressCount = (offer) => {
    if (this.props.pathwayToOffers) {
      let matchingProgress = this.props.pathwayToOffers.filter((f) => {
        return f.offerId === offer._id;
      });
      if (matchingProgress.length > 0) {
        let orderCount = matchingProgress.reduce((total, obj) => {
          return (total = total + Number(obj.orderCount));
        }, 0);
        return offer.type === '1'
          ? Number(offer.quantity) - orderCount
          : Number(offer.noOfOrders) - orderCount;
      } else
        return offer.type === '1'
          ? Number(offer.quantity)
          : Number(offer.noOfOrders);
    } else
      return offer.type === '1'
        ? Number(offer.quantity)
        : Number(offer.noOfOrders);
  };

  getProgressLength = (offer) => {
    if (this.props.pathwayToOffers) {
      let matchingProgress = this.props.pathwayToOffers.filter((f) => {
        return f.offerId === offer._id;
      });
      if (matchingProgress.length > 1) {
        return '100%';
      } else if (matchingProgress.length === 1) {
        return `${parseInt(
          (matchingProgress[0].orderCount /
            (offer.type === '1'
              ? Number(offer.quantity)
              : Number(offer.noOfOrders) || 1)) *
            100,
          10
        )}%`;
      } else {
        return '0%';
      }
    }
  };

  render() {
    const { close, loyaltyOpen } = this.props;
    let loyaltyDesktopClass = classNames({
      'orderViews itemV active':
        this.props.initiateDesktopLoyaltyFlow === true &&
        this.props.rightSideViewVisibilityIndex === 8,
      'orderViews itemV': !(
        this.props.initiateDesktopLoyaltyFlow === true &&
        this.props.rightSideViewVisibilityIndex === 8
      ),
    });

    const transitionStyles = {
      entering: { transform: `translateX(100%)` },
      entered: { transform: `translateX(0)` },
      exiting: { transform: `translateX(100%)` },
      exited: { transform: `translateX(100%)`, display: `none` },
    };

    return (
      <Transition timeout={250} mountOnEnter unmountOnExit in={loyaltyOpen}>
        {(state) => (
          <div
            className='wrapper loyalty-desktop'
            style={{
              zIndex: 9,
              position: `absolute`,
              background: `white`,
              width: `100%`,
              height: `100%`,
              top: `98px`,
              right: 0,
              transition: `transform .25s ease-out`,
              ...transitionStyles[state],
            }}
          >
            <header id='header' className='gold'>
              <div className='loyalty-container'>
                <div className='top-box'>
                  <button
                    className='card__cntrl__white'
                    onClick={close}
                  ></button>
                  <div className='top-nav'>
                    <a onClick={() => this.handleSignIn()}>
                      <span className='icon_loy-circle_user'></span>
                      {this.props.currentUser &&
                      this.props.currentUser.phoneNumber &&
                      this.props.userDetails &&
                      this.props.userDetails.firstName
                        ? this.props.userDetails.firstName
                        : 'Account'}
                    </a>
                  </div>
                </div>
                <h1 className='header-title'>
                  Loyalty <span>(Online Only)</span>
                </h1>
                <div className='bottom-box'>
                  <div className='mobile-nav'>
                    <ul>
                      <li>
                        <a
                          title='Offers'
                          className={
                            this.state.selectedCategory === 'offers'
                              ? 'active'
                              : ''
                          }
                          onClick={() => this.handleCategory('offers')}
                        >
                          <span className='icon_loy-circle_precent'></span>
                          Offers
                        </a>
                      </li>
                      {/* <li>
                      <a
                        title='Membership'
                        className={
                          this.state.selectedCategory === 'membership'
                            ? 'active'
                            : ''
                        }
                        onClick={() => this.handleCategory('membership')}
                      >
                        <span className='icon_loy-circle_star'></span>Membership
                      </a>
                    </li> */}
                    </ul>
                  </div>
                </div>
              </div>
            </header>
            <main id='main-content'>
              <section className='section-discount-cards'>
                <div className='loyalty-container loyalty-container-overflow'>
                  <React.Fragment>
                    {this.props.offers && (
                      <ul
                        className='offer-card-list'
                        style={{
                          display:
                            this.state.selectedCategory === 'offers'
                              ? 'block'
                              : 'none',
                        }}
                      >
                        {this.props.offers.map((offer, m) => (
                          <li key={m}>
                            <div
                              className='offer-card-box'
                              style={{ backgroundImage: `url(${offer.urlS3})` }}
                            >
                              <div className='inner-table'>
                                <div className='column'>
                                  <h2 className='offer-title'>{offer.name}</h2>
                                </div>
                              </div>
                            </div>
                            {this.props.currentUser &&
                            this.props.currentUser.phoneNumber &&
                            this.props.userDetails &&
                            this.props.userDetails.firstName ? (
                              <div className='next-card-level'>
                                <div className='card-progress'>
                                  <div
                                    className='progress-line'
                                    style={{
                                      width: this.getProgressLength(offer),
                                    }}
                                  ></div>
                                </div>
                                {this.getOfferUnlockStatus(offer) ? (
                                  <p className='text'>
                                    Congratulation! You have unlocked
                                    <span>{this.getOfferReward(offer)}</span>.
                                    Just add to cart and claim
                                  </p>
                                ) : (
                                  <p className='text'>
                                    {`You’re`}
                                    {this.getProgressCount(offer) < 5
                                      ? ` only ${this.getProgressCount(offer)}`
                                      : ` ${this.getProgressCount(offer)}`}
                                    <span>{this.getSizeString(offer)}</span>
                                    <span>{`${
                                      offer.type === '1'
                                        ? offer.categoryDisplayName
                                        : 'orders'
                                    } `}</span>
                                    away from a
                                    <span>{this.getOfferReward(offer)}</span>
                                  </p>
                                )}
                              </div>
                            ) : (
                              <div className='card-nav-box'>
                                <div className='card-nav-table'>
                                  <div className='inner-box'>
                                    <p className='text'>View your progress</p>
                                  </div>
                                  <div className='inner-box'>
                                    <a
                                      className='btn'
                                      title='Sign In'
                                      onClick={() => this.handleSignIn()}
                                    >
                                      Sign In
                                    </a>
                                  </div>
                                </div>
                              </div>
                            )}
                          </li>
                        ))}
                      </ul>
                    )}
                    <ul
                      className='discount-card-list'
                      style={{
                        display:
                          this.state.selectedCategory === 'membership'
                            ? 'block'
                            : 'none',
                      }}
                    >
                      <li>
                        <div className='discount-card-box bronze'>
                          <div className='top-box'>
                            <div className='card-logo-box'>
                              <img
                                src='https://s3-ap-southeast-2.amazonaws.com/lacampa/assets/logo.svg'
                                alt=''
                              />
                            </div>
                            <span className='privileges'>5% Discount</span>
                          </div>
                          <div className='bottom-box'>
                            <div className='inner-table'>
                              <div className='column'>
                                <div className='card-info'>
                                  <span className='member-name'>
                                    Johnny Appleseed
                                  </span>
                                  <span className='member-status'>
                                    Member Since 10/18
                                  </span>
                                </div>
                              </div>
                              <div className='column col-name'>
                                <span className='card-name'>Bronze</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </li>
                      <li>
                        <div className='discount-card-box gold'>
                          <div className='top-box'>
                            <div className='card-logo-box'>
                              <img
                                src='https://s3-ap-southeast-2.amazonaws.com/lacampa/assets/logo.svg'
                                alt=''
                              />
                            </div>
                            <span className='privileges'>
                              10% Discount & Free Delivery
                            </span>
                          </div>
                          <div className='bottom-box'>
                            <div className='inner-table'>
                              <div className='column'>
                                <div className='card-info'>
                                  <span className='member-name'>
                                    Johnny Appleseed
                                  </span>
                                  <span className='member-status'>
                                    Future Member
                                  </span>
                                </div>
                              </div>
                              <div className='column col-name'>
                                <span className='card-name'>Gold</span>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className='next-card-level'>
                          <div className='card-progress'>
                            <div
                              className='progress-line'
                              style={{ width: '71%' }}
                            ></div>
                            <div
                              className='progress-line end'
                              style={{ width: '30%' }}
                            ></div>
                          </div>
                          <p className='text'>
                            Only <span>4 orders</span> away from
                            <span>gold membership!</span>
                          </p>
                        </div>
                      </li>

                      <li>
                        <div className='discount-card-box platinum'>
                          <div className='top-box'>
                            <div className='card-logo-box'>
                              <img
                                src='https://s3-ap-southeast-2.amazonaws.com/lacampa/assets/logo.svg'
                                alt=''
                              />
                            </div>
                            <span className='privileges'>
                              10% Discount & Free Delivery
                            </span>
                          </div>
                          <div className='bottom-box'>
                            <div className='inner-table'>
                              <div className='column'>
                                <div className='card-info'>
                                  <span className='member-name'>
                                    Johnny Appleseed
                                  </span>
                                  <span className='member-status'>
                                    Future Member
                                  </span>
                                </div>
                              </div>
                              <div className='column col-name'>
                                <span className='card-name'>Platinum</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </React.Fragment>
                </div>
              </section>
            </main>
            <footer id='footer'></footer>
          </div>
        )}
      </Transition>
    );
  }
}

LoyaltyDesktop.propTypes = {
  isItemViewVisible: PropTypes.any,
};

export default LoyaltyDesktop;
